import socketIoAPI from '@/modules/socketAPI.js'

socketIoAPI.onNewConnection(function(socketVar) {
    socketVar.on('devUsersPing', function(data) {
        console.log('devUsersPing', data)
    })
})